/**
 * Overlay leave-panel rules — Stage 13.
 * /s/* (any query string) and /api/* native-navigate so Express serves the PDF.
 */

function sharePathname(href) {
  const raw = String(href || '').trim()
  if (!raw) return ''
  try {
    const u = raw.startsWith('//')
      ? new URL(`https:${raw}`)
      : new URL(raw, 'https://app.soviqai.com')
    return u.pathname || ''
  } catch {
    return raw.split('#')[0].split('?')[0]
  }
}

function isShareHref(href) {
  const path = sharePathname(href)
  return path.startsWith('/s/')
}

function shouldSkipOverlayCapture(href) {
  const path = sharePathname(href)
  return path.startsWith('/s/') || path.startsWith('/api/')
}

function shouldCaptureLeavePanel(href) {
  const raw = String(href || '').trim()
  if (!raw) return false
  if (shouldSkipOverlayCapture(raw)) return false
  if (raw.startsWith('//')) return false
  if (raw.startsWith('/')) return true
  try {
    const u = new URL(raw)
    return u.pathname.startsWith('/') && !shouldSkipOverlayCapture(raw)
  } catch {
    return false
  }
}

function leavePanelPlan(href) {
  return {
    closeOverlay: true,
    closeSheet: true,
    native: shouldSkipOverlayCapture(href),
    href: String(href || ''),
  }
}

export {
  sharePathname,
  sharePathname as hrefPathname,
  isShareHref,
  shouldSkipOverlayCapture,
  shouldCaptureLeavePanel,
  leavePanelPlan,
}
